export const COMPLETE_INTEGRATION_DESCRIPTION =
  'Your Account is fully onboarded and integrated with Fisherman! ' +
  'This means your website is able to process card payments.' +
  'Click “Manage Account” to access your Stripe account';
